module.exports = __webpack_public_path__ + "static/img/ff.7d266a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/ff.png
// module id = zcBt
// module chunks = 0